import { APP_VERSION } from 'src/app-version';

export const environment = {
    production: false,
    // Per-build favicon, applied by AppComponent on startup; null keeps favicon.ico.
    favicon: 'assets/img/favicon-uat.svg',
    langUrl: 'https://d18oow8b9b9oyq.cloudfront.net/bo/',
    version: 'v1',
    testId: null,
    appVersion: APP_VERSION,
    clientId: '90008', // static for bo-mz
    authServerUrls: ['https://app-bo-auth-uat-hhchd5gjb9ana5au.swedencentral-01.azurewebsites.net'],

    accountApiUrl:'not in use',
    apiUrl: 'not in use',
};
